import dataStore from '../../../../../../data/data';
import FacemeshInit from '../../../../../generator/load/facemesh';
import Mouth from './mouth';

class Face {
  constructor(target){
    this.target=target
  }

  async mouth(){
    await Mouth(this.target);
  }

  async data () {
    const facemesh=await FacemeshInit(this.target);
    dataStore.setState((_data) => ({
      ..._data,
      mediaprocessing: {
        ..._data.mediaprocessing,
        [this.target]:{
          ..._data.mediaprocessing[this.target],
          face: {
            ..._data.mediaprocessing[this.target].face,
            facemesh: facemesh,
          }
        }
      }
    }));
  }

  async run(){
    await this.data();
    await this.mouth();
  }
}

export default Face;
